import logo01 from './logos/logo-01.webp';
import logo02 from './logos/logo-02.webp';
import logo03 from './logos/logo-03.webp';
import logo04 from './logos/logo-04.webp';
import logo05 from './logos/logo-05.webp';
import logo06 from './logos/logo-06.webp';
import logo07 from './logos/logo-07.webp';
import logo08 from './logos/logo-08.webp';
import logo09 from './logos/logo-09.webp';
import logo10 from './logos/logo-10.webp';
import logo11 from './logos/logo-11.webp';
import logo12 from './logos/logo-12.webp';
import logo13 from './logos/logo-13.webp';
import logo14 from './logos/logo-14.webp';
import logo15 from './logos/logo-15.webp';
import logo16 from './logos/logo-16.webp';
import logo17 from './logos/logo-17.webp';
import logo18 from './logos/logo-18.webp';
import logo19 from './logos/logo-19.webp';
import logo20 from './logos/logo-20.webp';
import logo21 from './logos/logo-21.webp';
import logo22 from './logos/logo-22.webp';
import logo23 from './logos/logo-23.webp';
import logo24 from './logos/logo-24.webp';

export const ONBOARDING_LOGOS = [
  logo01,
  logo02,
  logo03,
  logo04,
  logo05,
  logo06,
  logo07,
  logo08,
  logo09,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
  logo21,
  logo22,
  logo23,
  logo24,
] as const;
